module.exports = __webpack_public_path__ + "img/chat-pattern.d4beda7c.png";